export const blockIconsActivitiesPianoNew = (
	<span className='material-symbols-outlined'>piano</span>
);
